import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

function Tabs (props) {
  const { list, className, init } = props
  const [selected, setSelected] = useState(0)
  const initFlag = useRef(false)
  useEffect(()=>{
    if(!initFlag.current){
      init(setSelected)
      initFlag.current = true
    }

  },[init,initFlag])
  const renderList = () => {
    if (list && list.length > 0) {
      return list.map((item, index) => {
        const { label, onClick } = item
        const buttonOnClick = (e) => {
          e.preventDefault()
          setSelected(index)
          onClick()
        }
        return (
          <li key={index} className={`of-tabs__item${selected === index ? ' of-tabs__item--selected' : ''}`}>
            <button
              onMouseEnter={e=>{
                if(selected!==index){
                  const el = e.currentTarget
                  const list = Array.from(el.classList)
                  if(list && list.length>0 && !list.find(i=>i==="shades-primary-background-1-100")){
                    el.classList.add('shades-primary-background-1-100')
                  }
                }
              }}
              onMouseLeave={e=>{
                if(selected!==index){
                  const el = e.currentTarget
                  const list = Array.from(el.classList)
                  if(list && list.length>0 && list.find(i=>i==="shades-primary-background-1-100")){
                    el.classList.remove('shades-primary-background-1-100')
                  }
                }
              }}
              className={`of-tabs__button ${selected === index ? ' primary-border-1-100 primary-font-1-100 shades-primary-background-1-100' : 'lines-border-1-100 text-font-3-100'}`}
              onClick={buttonOnClick}>{label}</button>
          </li>
        )
      })
    }
  }
  return (
    <div className={`of-tabs${className ? ' ' + className : ''}`}>
      <ul className='of-tabs__list'>
        {renderList()}
      </ul>
    </div>
  )
}

Tabs.propTypes = {
  list: PropTypes.any,
  className: PropTypes.string,
  init: PropTypes.func
}

export default Tabs
